<div class="popup__scroll-content">
    <div class="popup__box">
        <fieldset class="popup__fieldset" [disabled]="isDisabled">
            <ng-content></ng-content>
        </fieldset>
    </div>
</div>
